<script>
import OrderForm from '../collection/_Form.vue'


export default {
  name: 'DriverOrderGeneralEdit',
  components: {
    OrderForm
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [],
      editOrderId: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.editOrderId = parseInt(this.$route.params.id);
    this.breadcrumbs = []
    if (this.$route.query.d !== undefined) {
      this.breadcrumbs.push({ text: 'ダッシュボード', disabled: false, to: '/driver/home', exact: true })
    } else {
      this.breadcrumbs.push({ text: '受注一覧', disabled: false, to: '/driver/orders/accepts', exact: true })
    }
    this.breadcrumbs.push({ text: '編集', disabled: true, to: '' })




  },
  methods: {}
}
</script>

<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <h2>
      一廃回収の編集
    </h2>
    <order-form :edit-order-id="editOrderId" callable-type="general" />
  </v-container>
</template>

<style scoped lang="scss">

</style>
